import Vue from 'vue'
import { getDulangPlugin } from '@du/dulang-vue2'
import { GetCdnApiRes } from '@du/dulang-core'
import { Context } from '@nuxt/types/app'

const version = '5.1.0'
const area = 'HK'
const testENV = ['dev', 'itxx', 'imf1', 'imf2', 'imf3', 'id1']
export default (ctx = <Context>{}) => {
  const { query } = ctx
  console.log('process.env.customEnv...', process.env.customEnv)
  let ENV = process.env.customEnv || 'pro'
  if (ENV === 'prod') {
    ENV = 'pro'
  }
  if (testENV.includes(ENV)) {
    ENV = 'imf1'
  }
  const plugin = getDulangPlugin({
    appId: 'poizon-h5-hybird',
    version,
    ENV,
    lang: (query.lang as string) || 'en',
    area,
    catchHandle: (error) => {
      console.error(error)
    },
    pageDataProcess(detail: GetCdnApiRes) {
      console.log((detail as any).type as string)
      return detail
    }
  })
  Vue.use(plugin)
}
